/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/exampleMethod.js';
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';
import './methods/customCounter.js';
import './methods/sliderCertificate.js';
import './methods/imageLazyLoadAnimation.js';
import './methods/footerDarkBg.js';
import './methods/mobileMenu.js';
import './methods/sliderBlocks.js';
import './methods/animIntro.js';
import './methods/animFadeBottom.js';
import './methods/animColorFill.js';
import './methods/sticky.js';
import './methods/animServicesCards.js';
import './methods/sliderImg.js';
import './methods/logoChange.js';
import './methods/controlPopup.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
    }
});

/* Components */
app.component('ExampleComponent', defineAsyncComponent(() => import('../../components/ExampleComponent.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
